import {Component, OnInit, ChangeDetectionStrategy} from '@angular/core';
import {HttpClient, HttpErrorResponse, HttpParams} from "@angular/common/http";
import {environment} from "../../../environments/environment";
import {ActivatedRoute, Router} from "@angular/router";
import {AuthenticationService} from "../../services/authentication.service";
import {ToastService} from "../../core/notifications/toast-service";
import {getErrorMessage} from "../../core/utils";

@Component({
  selector: 'app-patreon-link',
  standalone: true,
  imports: [],
  templateUrl: './patreon-link.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: './patreon-link.component.scss'
})
export class PatreonLinkComponent implements OnInit {

  constructor(private route: ActivatedRoute,
              private httpClient: HttpClient,
              private authService: AuthenticationService,
              private router: Router,
              private toastService: ToastService) {

  }

  ngOnInit() {
    this.authService.refreshUserState().then(
      () => {
        this.route.queryParams.subscribe(params => {
          const code = params['code'];
          const state = params['state'];

          let queryParameters = new HttpParams();
          queryParameters = queryParameters.append("code", code);
          queryParameters = queryParameters.append("state", state); // TODO random state and remember state to check
          this.httpClient.get(environment.apiUrl + "oauth/patreon/redirect", {
            params: queryParameters,
          })
            .subscribe({
              next: (value) => {
                this.toastService.showSuccess("Patreon Account erfolgreich verbunden!");
                this.toastService.showSuccess("Bitte neu einloggen");
                this.authService.signOut();
              },
              error: (err: HttpErrorResponse) => {
                this.toastService.showDanger("Patreon Account konnte nicht verbunden werden: " + getErrorMessage(err.error.errorCode));
                this.router.navigate(['/home/user'])
              }
            });
        });
      }
    )
  }
}
